import { Link } from "react-router-dom";

export default function HomePage() {
  return (
    <main
      className="checker-background flex min-h-screen flex-col items-center justify-center bg-[#17202B] bg-blend-overlay bg-cover bg-[url(https://images.unsplash.com/photo-1534258936925-c58bed479fcb?q=80&w=3431&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D)] p-8 text-center text-[#2D2D31]"
    >
      <div className="flex w-full max-w-2xl flex-col items-center gap-8">
        <img
          alt="Hey Coach AI logo"
          src="/logo_full.png"
          className="h-auto w-full max-w-md"
        />
        <div className="flex flex-col items-center gap-3">
          <h1 className="text-3xl font-bold tracking-[-0.44px] text-white">
            The platform where coaching happens
          </h1>
          <p className="text-lg tracking-[-0.44px] text-white">
            Whether you&apos;re leading a program or working through one, it all lives here.
          </p>
        </div>
        <div className="flex flex-col items-stretch gap-3 sm:flex-row sm:items-center sm:justify-center">
          <Link
            to="/login"
            className="inline-flex items-center justify-center gap-2 rounded-[14px] px-8 py-4 text-base font-semibold tracking-[-0.31px] text-white transition hc-brand-gradient hc-shadow-brand hover:brightness-110 active:scale-95"
          >
            Sign in
          </Link>
          <Link
            to="/register"
            className="inline-flex items-center justify-center gap-2 rounded-[14px] border border-white/30 px-8 py-4 text-base font-semibold tracking-[-0.31px] text-white transition hover:border-white/50 hover:bg-white/5 active:scale-95"
          >
            Create account
          </Link>
        </div>
      </div>
    </main>
  );
}
